<template>
  <HomeMobile v-if="isMobile" />
  <div class="body_bpx" v-else>
    <div class="body_bpx_right">
      <div @click="footer_clk" style="cursor: pointer;">
        <img class="body_bpx_right_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/fc37513cf0c7e7a3e50f633829a0b08d.png" alt="">
        <div class="body_bpx_right_txt">客服微信</div>
      </div>
      <div class="xian_t"></div>
      <div @click="footer_clk2" style="cursor: pointer;">
        <img class="body_bpx_right_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/b18fbb2aa50435d6eb3d4da772332a74.png" alt="">
        <div class="body_bpx_right_txt">公众号</div>
      </div>
      <div class="xian_t"></div>
      <div @click="footer_clk3" style="cursor: pointer;">
        <img class="body_bpx_right_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/3bf4648bbcc7f4b0b115fdcf8116eec4.png" alt="">
        <div class="body_bpx_right_txt">邮箱</div>
      </div>


      <!-- <div class="right_box1" v-if="isbool === true">
        400-9794-2934
      </div> -->
      <div class="right_box3" v-if="isbool3 === true">
        baobitong@ufozx.com
      </div>
      <div class="right_box12" v-if="isbool2 === true">
        <img class="right_box12_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/90bdab7f50f613d3350815fbcd2d6384.png" alt="">
      </div>
      <div class="right_box1" v-if="isbool === true">
        <img class="right_box12_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250328/e9ea8eb5d66e3c4a6f165a7cf12b3ac5.jpg" alt="">
      </div>

    </div>
    <!-- scrollTop -->
    <div class="tab_box" :class="{ 'scrollTop_clk': scrollTop > 100 }">

      <div style="display: flex;">
        <img class="tab_box_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/293537d810fbccc1f3f9ee13da6232b9.png" alt="">
        <div class="tab_box_txt_l"><span>保彼通</span><span class="tab_box_txt_r">BobiTon</span></div>
      </div>
      <div class="tab_box_txt">
        <div class="tab_box_txt_cld" :class="{ 'tab_box_txt_cld_box': scrollTop >= 0 && scrollTop < 1650 }"
          @click="scrollToSavedPosition(0)">首页</div>
        <div class="tab_box_txt_cld" :class="{ 'tab_box_txt_cld_box':   scrollTop >= 1650 && scrollTop < 5000  }"
          @click="scrollToSavedPosition(1650)">产品服务</div>
        <div class="tab_box_txt_cld" :class="{ 'tab_box_txt_cld_box': scrollTop >= 5000 }"
          @click="scrollToSavedPosition(7500)">关于我们</div>
        <div class="tab_box_txt_cld" @click="scrollToSavedP">开放平台</div>
        <div class="tab_box_txt_cld" @click="router_app">保彼通APP</div>
      </div>


    </div>
    <!-- end -->
    <!-- title -->
    <div class="title_box">
      <img class="title_box_bg"
        src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/12fa3f2dcb094fef64d3e2133fc9e436.png" alt="">
      <div class="w_1200">
        <div class="title_box_txt">保彼通数智分销平台</div>
        
        <div class="title_box_txt2">BobiTon Smart Distribution Platform</div>
        <div class="title_btn_box_top">
          <div class="title_btn_box">
            <div class="title_btn">
              <img class="title_btn_img"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/750a444a9e563bb61da9ee8fb16283bb.png"
                alt="">
              <div>优艾弗欧自主研发</div>
            </div>
            <div class="title_btn2">
              <img class="title_btn_img"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/750a444a9e563bb61da9ee8fb16283bb.png"
                alt="">
              <div>500+分销商在线运营</div>
            </div>
          </div>
          <div class="title_btn_box">
            <div class="title_btn">
              <img class="title_btn_img"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/750a444a9e563bb61da9ee8fb16283bb.png"
                alt="">
              <div>400+品牌入驻</div>
            </div>
            <div class="title_btn2">
              <img class="title_btn_img"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/750a444a9e563bb61da9ee8fb16283bb.png"
                alt="">
              <div>线上GMV已突破2000w+元</div>
            </div>
          </div>
        </div>
        <div class="title_btn_jea" @click="showImagePreview">立即体验</div>
      </div>
      <div>
      </div>
    </div>
    <!-- end -->
    <!-- center -->
    <div class="center_box">
      <div class="w_1200">
        <div class="center_box_title">我们的产品优势</div>
        <div class="center_box_tab_box">
          <div class="center_box_tab" :class="{ 'num1_clk': num1 === 1 }" @click="num1 = 1">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num1 === 1 }"></div>
            <div class="center_box_tab_r">专业SAAS工具服务商</div>
          </div>
          <div class="center_box_tab" :class="{ 'num1_clk': num1 === 2 }" @click="num1 = 2">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num1 === 2 }"></div>
            <div class="center_box_tab_r">解决私域供货难题</div>
          </div>
          <div class="center_box_tab" :class="{ 'num1_clk': num1 === 3 }" @click="num1 = 3">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num1 === 2 }"></div>
            <div class="center_box_tab_r">洞察市场产品迭代快速</div>
          </div>
        </div>
        <div>
          <div class="center_swiper" v-if="num1 === 1">
            <div class="center_swiper_l">
              <div class="center_swiper_l_txt">通过多平台聚合，精准对接中大型企业级招商团队及媒体机构，打造高效精准的运营模式。</div>
              <div class="center_swiper_l_flex_box">
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">智能化、数字化的运营能力</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">深度挖掘企业级招商团队的运营痛点</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">精准掌握企业级招商团队的运营数据</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">优化企业级招商团队的运营效率</div>
                </div>
              </div>
            </div>
            <img class="center_swiper_r"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/5468e6a90e409aba5fbfc47dc2eba955.png"
              alt="">
          </div>
          <div class="center_swiper" v-if="num1 === 2">
            <div class="center_swiper_l">
              <div class="center_swiper_l_txt">系统通过智能化、数字化的运营方式，实现了对公域流量和私域流量的全面管理与优化。</div>
              <div class="center_swiper_l_flex_box">
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">通过任务发布、交易结算和数据追踪等功能，深度挖掘公域流量的价值</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">构建起从公域流量获取到销售转化的完整业务链路</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">通过实时监控和分析，赋能供应链优化与农业产品高效流通</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">助力乡村振兴和消费升级，为农业产品高质量发展提供有力支持</div>
                </div>
              </div>
            </div>
            <img class="center_swiper_r"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/89aac1aa1dfdf93ddcf1710ae3fdd3ba.png"
              alt="">
          </div>
          <div class="center_swiper" v-if="num1 === 3">
            <div class="center_swiper_l">
              <div class="center_swiper_l_txt">保彼通凭借其强大的市场洞察力和精准的应变能力，在复杂多变的市场环境中展现出卓越的适应力。</div>
              <div class="center_swiper_l_flex_box">
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">通过先进大数据分析，能够快速识别市场趋势并灵活调整产品策略</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">满足客户的基本需求，更能通过持续的产品优化和创新</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">帮助合作伙伴实现高效运营和业绩增长</div>
                </div>
                <div class="center_swiper_l_flex">
                  <img class="center_swiper_l_img"
                    src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                    alt="">
                  <div class="center_swiper_l_txt">始终致力于为客户创造价值，推动行业整体发展</div>
                </div>
              </div>
            </div>
            <img class="center_swiper_r"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/b66741848aa74f6d6f90bfa62cdf14ae.png"
              alt="">
          </div>


          <div class="center_swiper_box_box">
            <div class="center_swiper_box">

            </div>
            <div class="center_swiper_box_r">
              保彼通平台致力于构建一个精准营销、数据驱动、公平透明的合作生态，为电商商家与达人合作提供解决方案。平台通过平台充值、发布精准任务、精准分销等创新功能，为商家提供精准营销、数据驱动的精准营销服务，为达人提供公平、透明、高效的合作模式，助力商家与达人达成共赢。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center_box2">
      <div class="w_1200">
        <div class="center_box2_txt">保彼通bobiton工作台</div>
        <div class="center_box2_txt2">精准发布任务，快速申请样品，随身追踪订单，从分销者日常运营所需，到企业级招商需求，都得到了高效执行和精准运营的支持。</div>
        <div class="center_box2_btn_box">
          <div>
            <!-- num2 -->
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 1 }" @mousemove="num2 = 1">
              <div>任务主页</div>
              <div v-if="num2 === 1" class="center_box2_btn_txt">任务细分为公开、专属，响应不同达人的不同带货需求，为达人定制专属任务补贴比例。</div>
            </div>
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 2 }" @mousemove="num2 = 2">
              <div>选品大厅</div>
              <div v-if="num2 === 2" class="center_box2_btn_txt">海量产品根据不同类目、价格、达人佣金、服务费供分销者和达人选择。</div>
            </div>
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 3 }" @mousemove="num2 = 3">
              <div>达人申样</div>
              <div v-if="num2 === 3" class="center_box2_btn_txt">达人批量化申样操作、达人交付率浅而易见，提高分销者申样效率，让工作变得快捷高效。</div>
            </div>
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 4 }" @mousemove="num2 = 4">
              <div>申样跟踪管理</div>
              <div v-if="num2 === 4" class="center_box2_btn_txt">在小程序申样列表可进行申样进度跟踪,将申样负责人及每个环节的时间节点透明化管理。</div>
            </div>
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 5 }" @mousemove="num2 = 5">
              <div>任务订单数据</div>
              <div v-if="num2 === 5" class="center_box2_btn_txt">实时同步更新订单数据，精准计算有效销售金额及预估佣金，多维筛选查看功能一目了然。</div>
            </div>
            <div class="center_box2_btn" :class="{ 'num2_cla': num2 === 6 }" @mousemove="num2 = 6">
              <div>分佣无门槛提现</div>
              <div v-if="num2 === 6" class="center_box2_btn_txt">精准分置钱包账户，零门槛零手续费提现，实时到账，佣金进出明细详尽。</div>
            </div>

          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 1">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/dce13e6a19057f2d8d32f2f3ac26a5dc.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/d27b0f83af648f1c0b6428663bde470d.png"
              alt="">
          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 2">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/74aed9894d4f123ca8fe8860a2cd1ef5.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/d27b0f83af648f1c0b6428663bde470d.png"
              alt="">
          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 3">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/62c93c92d860844ac501eca3eff62ad7.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/0cfe58ce74c4fdf28da1f27203389354.png"
              alt="">
          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 4">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82f03ec0ec47ed6ef964af940ff5c2a5.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/0864b773e11ff259e16d074e0f1a1d6f.png"
              alt="">
          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 5">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/f0c447b8afcb8ffeb3c142d40559869d.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/4d8fef942fd6787c7a057a238eeb4801.png"
              alt="">
          </div>
          <div class="center_box2_btn_box_r" v-if="num2 === 6">
            <img class="center_box2_btn_box_r_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/d1cf469cb54ec2fc3551183bb2bd1f32.png"
              alt="">
            <img class="center_box2_btn_box_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/25683c30b2e12778f6bc697eda26e94f.png"
              alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <div class="center_box">
      <div class="w_1200">
        <div class="center_box_title">保彼通招商工作台</div>
        <div class="center_box_tab_box">
          <div class="center_box_tab" :class="{ 'num3_cla': num3 === 1 }" @click="num3 = 1">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num3 === 1 }"></div>
            <div class="center_box_tab_r">企业管理</div>
          </div>
          <div class="center_box_tab" :class="{ 'num3_cla': num3 === 2 }" @click="num3 = 2">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num3 === 2 }"></div>
            <div class="center_box_tab_r">团队管理</div>
          </div>
          <div class="center_box_tab" :class="{ 'num3_cla': num3 === 3 }" @click="num3 = 3">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num3 === 3 }"></div>
            <div class="center_box_tab_r">达人管理</div>
          </div>
          <div class="center_box_tab" :class="{ 'num3_cla': num3 === 4 }" @click="num3 = 4">
            <div class="center_box_tab_l" :class="{ 'num3_cla2': num3 === 4 }"></div>
            <div class="center_box_tab_r">活动管理</div>
          </div>
        </div>

        <div class="flex_bt">
          <div class="center_box_b">
a
            <img class="center_box_b_img" v-if="num3 === 1"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/9decb345319cc63aacdd0df45687221f.png"
              alt="">
            <img class="center_box_b_img" v-if="num3 === 2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/cd34d610eada160ead3ae75e7dbbc04f.png"
              alt="">
            <img class="center_box_b_img" v-if="num3 === 3"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/1346e7d406be89da3caaf04581cf9e5a.png"
              alt="">
            <img class="center_box_b_img" v-if="num3 === 4"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/6bffccce8be41a42ef1c1bf8cc3228b6.png"
              alt="">


          </div>
          <div class="center_box_b_box" v-if="num3 === 1">
            <div class="center_box_b_box_t">支持企业自定义设置</div>
            <div class="center_box_b_box_b">
              企业可自由选择保彼通提供的账号进行后台登录，以避免企业或第三方自行看到平台相关隐私信息。企业可灵活配置权限以满足不同业务需求，支持自定义的企业名称、企业介绍等重要信息，有助于提升企业品牌形象，增强员工对企业认同感。
            </div>
          </div>
          <div class="center_box_b_box" v-if="num3 === 2">
            <div class="center_box_b_box_t">多部门、多层级、多角色数据分权管理</div>
            <div class="center_box_b_box_b">
              系统框架支持【超级管理组】-【高级管理组】-【机构管理员】-【高级机构招商】-【初级机构招商】等，支持多层级管理，支持部门管理员根据需要自主添加员工
              【超级管理组】拥有最高权限可查看所有机构、平台、商家全部业绩情况；
              【高级管理员】负责分配商家账号及查看平台所有成员业绩情况；
              【机构管理员】查看所属机构全部成员业绩情况；

            </div>
          </div>
          <div class="center_box_b_box" v-if="num3 === 3">
            <div class="center_box_b_box_t">达人自由录入、寄样管理</div>
            <div class="center_box_b_box_b">
              申请样品管理采用智能绑定技术，将分销者和达人信息自动绑定至样品申请，实现精准匹配。该系统支持分销者为达人批量配送样品，提升效率。同时，系统具备实时监控功能，实时统计达人出单情况、未出单情况及样品寄送情况，为销售决策提供支持。该解决方案通过自动化处理和高效管理，助力企业提升运营效率和客户满意度。
            </div>
          </div>
          <div class="center_box_b_box" v-if="num3 === 4">
            <div class="center_box_b_box_t">活动集中管理、支持多员工分配</div>
            <div class="center_box_b_box_b">
              通过智能绑定技术，将活动对象精准分配至多个人员或团队，有效避免因活动限制而难以吸引目标员工参与。活动状态清晰区分，采用自动化处理技术，实时统计活动审核通过商品数、待审核商品数及申请商品情况，为公司运营决策提供科学依据。通过精准匹配、高效管理，该解决方案显著提升了活动的参与度，助力公司提升运营效率和客户满意度。
            </div>
          </div>
        </div>
        <div>

        </div>

      </div>
    </div>
    <!-- end -->
    <div class="center3_box">
      <div class="center3_box_txt">深入理解业务，让每个角色都能为团队提升效率贡献力量</div>
      <div class="w_1200">
        <div class="center3_box_box_box">
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/f3dfe6992d3e73d7789ebc3834b4ba1c.png"
              alt="">
            <div class="center3_box_box_txt">活动管理</div>
            <div class="center3_box_box_txt2">
              精准分配活动发布权限，提升活动发布效率，同时系统支持多维度活动管理，从商品报名、推广到结束进行统一管理，为商家和团队提供高效便捷、灵活的活动管理服务。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/a4e05fa608899b24075c72a92aa25fe1.png"
              alt="">
            <div class="center3_box_box_txt">商品管理</div>
            <div class="center3_box_box_txt2">
              系统通过智能化技术实现商品审核与实时佣金变化监控，从商品报名、推广、到结束进行多维度统一管理团长商品，为商家提供高效、精准的物流管理与订单处理服务。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/e65ca0e4cbe83d95e6a8272d707c6539.png"
              alt="">
            <div class="center3_box_box_txt">样品管理</div>
            <div class="center3_box_box_txt2">
              支持实时跟踪达人样品物流信息，一键查询到货情况，流转数据清晰，为商家提供高效管理与精准配送的解决方案。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/12f156ec8836638801c0b9468637dcdb.png"
              alt="">
            <div class="center3_box_box_txt">订单管理</div>
            <div class="center3_box_box_txt2">
              系统实时更新付款订单明细，精准统计助力数据化运营，可准确查找每笔订单明细情况，精准管理每笔订单。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/780bcc9db8e0a2958abea4280a580417.png"
              alt="">
            <div class="center3_box_box_txt">任务管理</div>
            <div class="center3_box_box_txt2">
              招商可实时监控和跟踪任务进度，全面掌握达人带货、出单等关键环节的情况，精准掌握任务的销售数据，对产品的销售情况了如指掌。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/411ab8a47786cb6bcd41956dd2dec579.png"
              alt="">
            <div class="center3_box_box_txt">绩效管理</div>
            <div class="center3_box_box_txt2">
              招商系统实时监控任务进度，精准掌握商品审核量、达人申请量、成交单量、跑单的商品情况以及系统上线情况。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/e969d5f03dc031fc0a7e5e4b55efb4cf.png"
              alt="">
            <div class="center3_box_box_txt">达人管理</div>
            <div class="center3_box_box_txt3">
              通过智能匹配技术实现样品申请与分销者及达人精准匹配，采用自动化处理技术支持多人员操作，减少资源浪费，提升效率；实时监控功能帮助商家分析销售数据，优化运营，提升客户满意度。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/03b78756b7212b53155f0025abd399e4.png"
              alt="">
            <div class="center3_box_box_txt">排行管理</div>
            <div class="center3_box_box_txt3">
              实时追踪商品、分销者、招商及达人运营，掌握审核量、成交情况、达人申请量、跑单量等关键数据，全面了解任务进度、订单情况及销售数据。实时监控商品销售动态，及时识别爆单，快速掌握市场动态；实时查看员工工作情况，为团队管理提供支持。
            </div>
          </div>
          <div class="center3_box_box">
            <img class="center3_box_box_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/b78556b83bef859327d988d89bddbedd.png"
              alt="">
            <div class="center3_box_box_txt">企业管理</div>
            <div class="center3_box_box_txt3">
              用户可自由选择保彼通提供的账号进行后台登录，以保护企业隐私信息，灵活配置权限设置以满足不同业务需求，塑造品牌形象，提升员工归属感。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <div class="center_box m_b_56">
      <div class="w_1200">
        <div class="center_box_title">商家端</div>
        <div class="center_box2_txt3">无论品牌商家还是团长机构，全场景、全平台、全链路数字化一站式解决方案</div>
        <img class="center_box_title_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/72ee5b6e35b8f35e076fcb6d052a19c4.png" alt="">
      </div>
    </div>
    <!-- end -->
    <div class="xian_box"></div>
    <div class="center_box">
      <div class="w_1200">

        <div class="center_box_tab_box">
          <div class="center_box_tab" :class="{ 'num4_clk': num4 === 1 }" @click="num4 = 1">
            <div class="center_box_tab_l" :class="{ 'num4_clk2': num4 === 1 }"></div>
            <div class="center_box_tab_r">招商</div>
          </div>
          <div class="center_box_tab" :class="{ 'num4_clk': num4 === 2 }" @click="num4 = 2">
            <div class="center_box_tab_l" :class="{ 'num4_clk2': num4 === 2 }"></div>
            <div class="center_box_tab_r">分销者</div>
          </div>
        </div>
        <div class="center_box2_txt3">无论你是招商人员还是分销者都能找到契合使用场景的业务解决方案。</div>
        <img class="center_box2_txt3_img" v-if="num4  === 1"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/fd25cfcfa1755a49531598d27c1d14ec.png" alt="">
        <img class="center_box2_txt3_img" v-if="num4  === 2"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250328/80fee26e006709232c6c61aa9e073b51.jpg" alt="">


        <div class="center_box2_txt4" v-if="num4 === 1">招商：招商专员负责寻找优质商家资源、提报活动、审核商品质量、发布任务、协商产品优惠力度及推广佣金细节。</div>
        <div class="center_box2_txt4" v-if="num4 === 2">分销者：精准定位管理主播达人，通过模块化推广运营管理提升推广效率，实现事半功倍的推广效果。</div>
        <div class="center_swiper_l_flex_box" style="margin-top: 40px;" v-if="num4 === 1">
          <div class="center_swiper_l_flex">
            <img class="center_swiper_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
              alt="">
            <div class="center_swiper_l_txt2">
              <div>*活动创建、商品审核、任务发布、跨平台交互</div>
              <div> 招商员工可直接在后台，完成“活动创建”“商品审核”“任务发布”“申样流程”等一系列工作。</div>
            </div>
          </div>
          <div class="center_swiper_l_flex">
            <img class="center_swiper_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
              alt="">


            <div class="center_swiper_l_txt2">
              <div>*系统全自动同步活动，同步商品</div>
              <div>系统自动同步招商后台创建的活动和添加的商品，无需其他导出导入操作。</div>
            </div>
          </div>
          <div class="center_swiper_l_flex">
            <img class="center_swiper_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
              alt="">
            <div class="center_swiper_l_txt2">
              <div>*数据自动同步，多维度提供榜单数据</div>
              <div>自动同步招商工作数据，无需任何手动计算，可直接进行多维度分析数据</div>
            </div>
          </div>

        </div>
        <div class="center_swiper_l_flex_box" style="margin-top: 40px;" v-if="num4 === 2">
          <div class="center_swiper_l_flex">
            <img class="center_swiper_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
              alt="">


            <div class="center_swiper_l_txt2">
              <div> *达人管理，商品分发给“主播达人”</div>
              <div>分销者自由录入主播达人，给达人申样、领任务系统自动跟踪达人出单情况。</div>
            </div>
          </div>
          <div class="center_swiper_l_flex">
            <img class="center_swiper_l_img"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
              alt="">



            <div class="center_swiper_l_txt2">
              <div>*数据成交订单同步，多维度提供榜单数据</div>
              <div>达人订单数据精准统计，商务BD业绩自动计算，分佣自动到账。</div>
            </div>
          </div>


        </div>
      </div>
      <div class="hz_boxs">合作伙伴</div>
    </div>
    <!-- end -->
    <div class="footer_box">
      <div class="w_1200">
        <div class="footer_box_box">
          <div class="footer_box_img"></div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import HomeMobile from './HomeMobile.vue'

export default {
  components: { HomeMobile },
  data() {
    return {
      isMobile: false,
      scrollTop: 0,
      num1: 1, // 我们的产品优势
      num2: 1, // 保彼通bobiton工作台
      num3: 1, // 保彼通招商工作台
      num4: 1,
      isbool: false,
      isbool2: false,
      isbool3: false,
      scale: 2

    };
  },

  mounted() {
    this.checkMobile()
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = document.documentElement.clientWidth < 768
    },
    router_app(){
      this.$router.push('/app')
    },
    scrollToSavedP() {
      this.$message('暂未开放～')
    },
    footer_clk() {
      console.log(123)
      this.isbool = !this.isbool
      this.isbool2 = false
      this.isbool3 = false
    },
    footer_clk2() {
      this.isbool2 = !this.isbool2
      this.isbool = false
      this.isbool3 = false
    },
    footer_clk3() {
      this.isbool3 = !this.isbool3
      this.isbool = false
      this.isbool2 = false
    },
    handleScroll() {
      this.scrollTop = window.scrollY
    },
    scrollToSavedPosition(num) {
      window.scrollTo({
        top: num,
        behavior: "smooth" // 平滑滚动
      });
    },

    showImagePreview(item) {
      const image = new Image();
      image.src = 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/dbca6f463f3839240de18f11d4f804af.jpg'
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.zIndex = 999999999999;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/dbca6f463f3839240de18f11d4f804af.jpg';
        previewImage.style.maxWidth = '80%';
        previewImage.style.maxHeight = '80%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    }

  }
};
</script>

<style>
.right_box12_img {
  margin: 11px 35px 0 24px;
  width: 110px;
  height: 110px;
}

.right_box3 {
  font-weight: 600;
  font-size: 22px;
  color: #3A70F5;
  position: absolute;
  left: -300px;
  top: 210px;
  width: 291px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/d16af99a0daa1d380d1a0a54e2313bc0.png');
  background-size: 291px 77px;
  height: 77px;
  text-align: center;
  line-height: 77px;
}

.right_box1 {
  position: absolute;
  left: -180px;
  top: 0px;
  width: 169px;
  background-size: 169px 137px;
  height: 137px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/8ffe1094e13381ffa5f9003c9a83817b.png');
}

.right_box12 {
  position: absolute;
  left: -180px;
  top: 90px;
  width: 169px;
  background-size: 169px 137px;
  height: 137px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/8ffe1094e13381ffa5f9003c9a83817b.png');
}

.body_bpx_right {
  z-index: 999999;
  padding: 20px 0;
  text-align: center;
  position: fixed;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 40px;
  width: 90px;
  height: 267px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  border-radius: 79px;
}

.xian_t {
  margin-top: 16px;
  margin-bottom: 16px;
  width: 77px;
  height: 1px;
  background-color: #E9E9E9;
  margin-left: 6px;

}

.body_bpx_right_img {
  width: 35px;
  height: 35px;
}

.body_bpx_right_txt {
  font-weight: 400;
  font-size: 17px;
  color: #666666;
}

.num1_clk {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%);
  color: #fff;
  border-radius: 34px;
}

.body_bpx {
  min-width: 1200px;
}

.tab_box_txt_r {
  font-size: 24px;
}

* {
  margin: 0;
}

.w_1200 {
  padding: 0 20px;
  width: 1200px;
  margin: auto;
}

.scrollTop_clk {
  background-color: #fff !important;
}

.tab_box {
  /* margin-bottom: 70px; */
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: space-evenly;
  /* width: 1200px; */
  margin: auto;
  height: 64px;
  line-height: 64px;
}

.tab_box_txt_l {
  font-weight: 600;
  font-size: 30px;
  color: #000000;
}



.tab_box_img {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  margin-top: 14px;
}

.tab_box_txt {
  cursor: pointer;
  display: flex;
}

.tab_box_txt_cld {
  font-weight: 600;
  font-size: 22px;
  color: #000000;
  margin-left: 90px;
}

.title_box {

  height: 714px;
  position: relative;
  width: 100%;


}

.title_box_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 714px;
  z-index: -1;
}

.title_box_txt {
  padding-top: 98px;
  width: 771px;
  height: 97px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 800;
  font-size: 65px;
  color: #1D58E9;
  line-height: 97px;
  text-shadow: 0px 4px 0px #FFFFFF;
  text-align: left;
  font-style: normal;
}

.title_box_txt2 {
  width: 786px;
  height: 42px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #3A70F5;
  line-height: 42px;
  letter-spacing: 2px;
  text-align: left;
  font-style: normal;
  text-transform: uppercase;
}

.title_btn_box_top {
  margin-top: 46px;
}

.title_btn_box {

  display: flex;
}

.title_btn {
  margin-bottom: 24px;
  margin-right: 46px;
  display: flex;
  width: 266px;
  padding: 0 16px;
  line-height: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  border: 2px solid #FFFFFF;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}

.title_btn2 {
  margin-bottom: 24px;
  margin-right: 46px;
  display: flex;
  /* width: 266px; */
  padding: 0 16px;
  line-height: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  border: 2px solid #FFFFFF;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}

.title_btn_img {
  margin-right: 12px;
  margin-top: 14px;
  width: 24px;
  height: 24px;
}

.title_btn_jea {
  margin-top: 40px;
  font-weight: 600;
  font-size: 38px;
  color: #FFFFFF;
  text-align: center;
  line-height: 92px;
  width: 411px;
  height: 92px;
  background: #3A70F5;
  box-shadow: 0px 8px 0px 0px #1352ED, inset 0px 2px 4px 0px rgba(255, 255, 255, 0.4);
  border-radius: 52px;
}

.center_box_tab_box {
  cursor: pointer;
  margin-top: 60px;
  display: flex;
  justify-content: space-evenly;
}

.center_box {

  background-color: #fff;
  min-height: 100px;
}

.center_box_title {
  text-align: center;
  margin-top: 70px;
  font-weight: 600;
  font-size: 40px;
  color: #000000;
}

.center_box_tab {
  padding: 0 27px;
  height: 64px;
  line-height: 64px;
  display: flex;
}

.center_box_tab_l {

  margin-right: 12px;
  border-radius: 14px;
  margin-top: 26px;
  width: 14px;
  height: 14px;
  background: #3A70F5;
}

.center_box_tab_r {
  font-weight: 600;
  font-size: 28px;
  /* color: #000000; */
}

.center_swiper {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
}

.center_swiper_l {}

.center_swiper_l_txt {
  width: 644px;
  height: 74px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
  line-height: 37px;
}

.center_swiper_r {
  width: 460px;
  height: 400px;
}

.center_swiper_l_img {
  width: 17px;
  margin-right: 20px;
  margin-top: 7px;
  height: 25px;
}

.center_swiper_l_flex_box {
  margin-top: 100px;
}

.center_box_tab:hover {
  border-radius: 34px;
  background-color: #DEE7FF !important;
}

.center_swiper_l_flex {
  margin-top: 30px;
  display: flex;
}

.center_swiper_l_txt {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  height: 30px;
}

.center_swiper_box_box {
  margin-bottom: 70px;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
}

.center_swiper_box {
  border-radius: 22px;
  width: 460px;
  height: 260px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/651a9ba5c0bc85a551ae417756262daf.png');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-size 0.3s ease-in-out, background-position 0.3s ease-in-out;
}

.center_swiper_box:hover {
  border-radius: 22px;
  background-size: 120%;
  background-position: center;
}

.center_swiper_box_r {
  width: 690px;
  height: 185px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #333333;
  line-height: 37px;
  text-align: left;
  font-style: normal;
  margin-top: 38px;
}

.center_box2 {
  padding-top: 55px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/7b7ba387eab5988eec5adda36175f22f.png');
  background-size: 100% 1055px;
  width: 100%;
  height: 1000px;
}

.center_box2_txt {
  font-weight: 600;
  font-size: 40px;
  color: #000000;
  height: 56px;
  text-align: center;
  line-height: 56px;
}

.center_box2_txt2 {
  margin-top: 12px;
  text-align: center;
  width: 1079px;
  height: 74px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #666666;
  line-height: 37px;
}

.center_box2_btn_box {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}

.center_box2_btn {
  cursor: pointer;
  margin-bottom: 30px;
  padding-left: 20px;
  width: 342px;
  /* height: 77px; */
  background: #D2E6FF;
  border-radius: 12px;
  line-height: 77px;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
}

.center_box2_btn_box_r {
  position: relative;
  margin-right: 90px;
  margin-top: 108px;
  width: 658px;
  height: 426px;
}

.center_box2_btn_box_r_img {

  width: 658px;
  height: 426px;
}

.center_box2_btn_box_l_img {
  width: 180px;
  height: 356px;
  position: absolute;
  bottom: 0;
  right: -90px;
}

.flex_bt {
  margin-bottom: 70px;
  display: flex;
  justify-content: space-between;
}

.center_box_b {

  margin-top: 50px;
  width: 646px;
  height: 414px;
}

.center_box_b_img {
  width: 646px;
  height: 414px;
}

.center_box_b_box {
  padding: 20px;
  margin-top: 120px;
  width: 453px;
  /* height: 236px; */
  background: #F2F7FF;
  border-radius: 12px;
}

.center_box2_btn_txt {
  font-weight: 400;
  margin-top: -10px;
  padding-bottom: 15px;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 30px;
}

.num2_cla {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%) !important;
  color: #fff;

}

.center_box_b_box_t {
  margin-bottom: 16px;
  height: 37px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
  line-height: 37px;
}

.center_box_b_box_b {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  line-height: 30px;
}

.center3_box {
  width: 100%;
  /* height: 1677px; */
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/b8ecad6ca60ef78d0ba927933926ddd3.png');
  background-size: 100% 1677px;
}

.center3_box_txt {
  margin-bottom: 50px;
  padding-top: 70px;
  height: 56px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 40px;
  color: #000000;
  line-height: 56px;
  text-align: center;
}

.center3_box_box_box {
  width: 1200px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;

}

.center3_box_box {
  cursor: pointer;
  margin-bottom: 30px;
  padding: 24px;
  width: calc(380px - 48px);
  /* height: calc(397px - 48px); */
  background: #FFFFFF;
  border-radius: 22px;
}

.center3_box_box:hover {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%) !important;
  color: #FFFFFF !important;
}

.center3_box_box_img {
  margin-left: 100px;
  width: 130px;
  height: 132px;
}

.center3_box_box_txt {
  text-align: center;
  margin-bottom: 10px;
  margin-top: 12px;
  height: 37px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  /* color: #000000; */
  line-height: 37px;
}

.center3_box_box_txt2 {
  height: 150px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  /* color: #666666; */
  line-height: 30px;
}

.center3_box_box_txt3 {
  height: 240px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  /* color: #666666; */
  line-height: 30px;
}

.center_box2_txt3 {
  font-weight: 400;
  font-size: 26px;
  color: #666666;
  text-align: center;
  height: 37px;
  line-height: 37px;
  margin-top: 30px;
}

.center_box_title_img {
  width: 100%;
  height: 758px;
  margin-top: 50px;
}

.m_b_56 {
  margin-bottom: 56px;
}

.xian_box {
  width: 100%;
  height: 20px;
  background: #F5F5F5;
}

.center_box2_txt3_img {
  margin-top: 50px;
  width: 100%;
  height: 750px;
}

.center_box2_txt4 {
  margin-top: 50px;
  height: 74px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
}

.center_swiper_l_txt2 {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  height: 60px;
  line-height: 30px;
}

.hz_boxs {
  margin-top: 70px;
  margin-bottom: 50px;
  font-weight: 600;
  font-size: 40px;
  color: #000000;
  text-align: center;
}

.footer_box {
  padding-top: 60px;
  width: 100%;
  height: 560px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/3364d096293a5cf93ea00b1e2ddd4b45.png');
  background-size: 100% 620px;
}

.footer_box_box {
  padding-top: 30px;
  /* margin-top: 60px; */
  border-radius: 24px;
  background-color: #fff;
  width: 100%;
  height: 490px;


}

.footer_box_img {
  /* background-position: center;
  background-repeat: no-repeat; */
  /* background-size: 1140px 460px; */
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/f97d7d233080e29e3edbbad3b8c88ce3.png');
  margin: 0 30px 30px 30px;
  width: 1140px;
  height: 460px;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-size 0.3s ease-in-out, background-position 0.3s ease-in-out;
}

.footer_box_img:hover {
  background-size: 114%;
  background-position: center;
}

.num3_cla {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%) !important;
  color: #fff !important;
  border-radius: 34px;
}

.num3_cla2 {
  background: #fff !important;
}

.num4_clk {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%) !important;
  color: #fff !important;
  border-radius: 34px;
}

.num4_clk2 {
  background-color: #fff;
}

.tab_box_txt_cld_box {
  color: #3A70F5;
  border-bottom: 4px solid #3A70F5;
}
</style>